//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex'
import { formatDistanceToNow } from 'date-fns'
import { groupBy } from 'lodash'
import { convertMinutes } from '@/utils/swoop'
import GQL from './gql'

export default {
  apollo: {
    ticketsForParent: GQL.ticketsForParent
  },

  data() {
    return {
      ticketsForParent: [],
      status: 'OPEN',
      statusOptions: [
        { label: 'ALL', value: 'ALL' },
        { label: 'OPEN', value: 'OPEN' },
        { label: 'CLOSED', value: 'CLOSED' }
      ],
      columns: [
        {
          label: 'ID',
          align: 'left'
        },
        {
          label: 'Sev',
          align: 'left'
        },
        {
          label: 'Type',
          align: 'left'
        },
        {
          label: 'Ticket identifier',
          align: 'left'
        },
        {
          label: 'State',
          align: 'left'
        },
        {
          label: 'Assigned to',
          align: 'left'
        },
        {
          label: 'NOC Time',
          align: 'left'
        },
        {
          label: 'Time open',
          align: 'left'
        },
        {
          label: 'Last updated',
          align: 'left'
        }
      ]
    }
  },

  computed: {
    ...mapState({
      serviceLocationId: state => state?.service?.service?.service_location_id
    }),

    tickets() {
      const tickets = this.ticketsForParent
      return groupBy(tickets, 'ticket_type')
    },

    showNoResults() {
      const payloadQty = this.ticketsForParent.length
      const apolloLoading = this.$apollo.queries.ticketsForParent.loading
      return !payloadQty && !apolloLoading
    }
  },

  methods: {
    ...mapMutations('service', ['OPEN_TICKET_QUICK_VIEW']),

    rowClick(ticket) {
      this.OPEN_TICKET_QUICK_VIEW(ticket.id)
    },

    ticketId(ticket) {
      return `${ticket.is_cf_ticket ? 'CFT' : 'PP'}#${ticket.id}`
    },

    type(ticket) {
      return ticket?.ticket_type || '--'
    },

    severity(ticket) {
      return !ticket?.severity || ticket.severity === 'UNDETERMINED'
        ? 'UNSET'
        : ticket.severity
    },

    identifier(ticket) {
      return ticket?.ticket_parent?.name || '--'
    },

    statusColor(status) {
      const colors = {
        OPEN: 'green',
        CLOSED: 'red'
      }

      return colors[status] || null
    },

    assignedTo(ticket) {
      return ticket?.assigned_user?.full_name || ticket?.team?.name || null
    },

    lastUpdated(date) {
      return date
        ? formatDistanceToNow(new Date(date.split(' ').join('T')), {
            addSuffix: true
          })
        : ''
    },

    fromMin(min) {
      return convertMinutes(min) || '--'
    }
  }
}
